import type { Space } from '@mail/cross-sizes-utils';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';

export enum UnlimitedDocumentsTariffType {
    document = 'document',
    spreadsheet = 'spreadsheet',
    presentation = 'presentation',
}

export interface UnlimitedDocumentsTariffInfo {
    id: string;
    space: Space;
    usualPrice: number;
    isTrial: boolean;
    type: UnlimitedDocumentsTariffType;
    discount?: number;
}

const unlimitedDocumentsTypeNameGenitives: { [k in UnlimitedDocumentsTariffType]: string } = {
    [UnlimitedDocumentsTariffType.document]: 'документов',
    [UnlimitedDocumentsTariffType.spreadsheet]: 'таблиц',
    [UnlimitedDocumentsTariffType.presentation]: 'презентаций',
};

export const getUnlimitedDocumentsTypeNameGenitive = (type: UnlimitedDocumentsTariffType) => {
    return unlimitedDocumentsTypeNameGenitives[type] || 'документов';
};

export const UNLIMITED_DOCUMENTS_BANNER_ID = 'unlim-docs-banner';

export const UNLIMITED_DOCUMENTS_RADAR_NAMES = {
    FAKEDOOR_MODAL: 'fakedoor_unlimited_docs',
    THANKS_MODAL: 'fakedoor_unlimited_docs_thanks',
    ASIDE_MODAL: 'fakedoor_unlimited_docs_aside',
    SIDEBAR_BANNER: 'fakedoor_unlimited_docs_banner',
};

export const enum UnlimitedDocumentsEntryPoint {
    HOME_PROMO = 'home_promo',
    ASIDE_PROMO = 'aside_promo',
    SIDEBAR_BANNER = 'sidebar_banner',
}

export const getUnlimitedDocumentsBannerStoreValue = (): { state: boolean; time: number; counts: { close: number; show: number } } => {
    return storeHelper.getValue(UNLIMITED_DOCUMENTS_BANNER_ID) || { state: false, time: 0, counts: { close: 0, show: 0 } };
};
